import { Component, OnInit } from '@angular/core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { RequestFieldFilterInterface } from 'src/app/util/interfaces/request';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { GroupManagerAnalystsService } from './service/group-manager-analysts.service';
import { AnalystInterface } from 'src/app/util/interfaces/register/analyst';
import { SolutionAreaInterface } from 'src/app/util/interfaces/register/solutionArea';
import { number } from 'echarts';
import { set } from 'cypress/types/lodash';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-group-manager-analysts',
	templateUrl: './group-manager-analysts.component.html',
	styleUrl: './group-manager-analysts.component.scss',
})
export class GroupManagerAnalystsComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_filtros_disponiveis: 'Available Filters',
		lbl_reiniciar_filtros: 'Restart Filters',
		lbl_geral_salvar: 'Save',
		lbl_salvo_com_sucesso: '',
		lbl_an_errour_occour: '',
		lbl_reiniciado_com_sucesso: '',
		lbl_geral_filtros_visiveis_para_usuario: '',
		lbl_geral_filtros_visiveis_para_analista: '',
		lbl_geral_selecao_filtros_ocultara_campos_correspondentes: 'Filter selection will hide the corresponding fields for these filters',
	};

	icons = {
		faInfoCircle: faInfoCircle,
	};

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private groupManagerAnalystsService: GroupManagerAnalystsService
	) {}

	isLoadingLabels = true;
	isLoadingFilters = true;
	isUpdating = false;
	idSolutionArea = 0;

	selectedFilterAnalyst: AnalystInterface[] = [];
	requestFilters: RequestFieldFilterInterface[] = [];

	filterOptionsSolutionArea: genericFormInterface[] = [
		{
			name: 'hideColumnsForSolutionArea',
			label: 'lbl_geral_grupos',
			inputType: 'select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterOptionsAnalyst: genericFormInterface[] = [
		{
			name: 'hideColumnsForAnalyst',
			label: 'lbl_geral_analistas',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
			disabled: true,
		},
	];

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.loadFilterOptions();
	}

	loadFilterOptions(): void {
		this.isLoadingFilters = true;
		const previousSolutionAreaId = this.idSolutionArea; // Salva o selecionado

		this.groupManagerAnalystsService.getSolutionAreasByAnalystId().subscribe({
			next: (data) => {
				this.filterOptionsSolutionArea[0].items = data.map((area) => ({
					name: area.solutionArea,
					label: area.solutionArea,
					value: area.id,
					values: [area.id],
				}));

				// Se o grupo selecionado ainda existe, mantém selecionado
				const stillExists = data.some((area) => area.id === previousSolutionAreaId);
				this.filterOptionsSolutionArea[0].values = stillExists ? [previousSolutionAreaId] : [];
				this.idSolutionArea = stillExists ? previousSolutionAreaId : 0;
			},
			complete: () => {
				this.isLoadingFilters = false;
			},
		});

		this.groupManagerAnalystsService.getAnalystsByCustomerId().subscribe({
			next: (data) => {
				this.filterOptionsAnalyst[0].items = data.map((analyst) => ({
					name: analyst.fullName,
					label: analyst.fullName,
					value: analyst.id,
					values: [analyst.id],
				}));
				this.filterOptionsAnalyst[0].disabled = true;
				this.filterOptionsAnalyst[0].rawValues = [];
				this.filterOptionsAnalyst[0].values = [];
			},
			complete: () => {
				this.isLoadingFilters = false;
			},
		});
	}

	onSolutionAreaChange(selectedSolutionAreaId: number) {
		this.isLoadingFilters = true;
		this.idSolutionArea = selectedSolutionAreaId;

		this.groupManagerAnalystsService.getAnalystBySolutionAreasId(selectedSolutionAreaId).subscribe({
			next: (data) => {
				// Mapeia todos analistas disponíveis para a solução
				const mappedAnalysts = data.map((analyst) => ({
					name: analyst.fullName,
					label: analyst.fullName,
					value: analyst.id,
					values: [analyst.id],
				}));

				this.filterOptionsAnalyst[0].values = [];
				this.filterOptionsAnalyst[0].rawValues = [];

				for (const analystItem of mappedAnalysts) {
					if (data.length > 0) {
						this.filterOptionsAnalyst[0].values.push(analystItem);
						this.filterOptionsAnalyst[0].rawValues.push(analystItem.value);
						this.filterOptionsAnalyst[0].disabled = false;
					}
				}
			},
			complete: () => {
				this.isLoadingFilters = false;
			},
		});
	}

	saveAnalystsToSolutionArea(): void {
		if (this.isUpdating) return;

		const selectedSolutionAreaId = this.idSolutionArea;
		const selectedAnalystIds = this.filterOptionsAnalyst[0].values.map((item) => item.value);

		this.isUpdating = true;
		this.isLoadingFilters = true;
		this.loadFilterOptions();

		if (!selectedSolutionAreaId) {
			this.NotificationService.setNotificationMessage('Selecione um grupo.');
			this.isUpdating = false;
			return;
		}

		// Mesmo que o delete falhe, tenta inserir normalmente
		this.groupManagerAnalystsService.insertAnalystsToSolutionArea(selectedSolutionAreaId, selectedAnalystIds).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage('Vínculos salvos com sucesso!');
				this.isUpdating = false;
				this.isLoadingFilters = false;
			},
			error: () => {
				this.NotificationService.setNotificationMessage('Erro ao salvar vínculos.');
				this.isLoadingFilters = false;
				this.isUpdating = false;
			},
			complete: () => {
				this.isUpdating = false;
				this.isLoadingFilters = false;
			},
		});
	}
}
